























































































































































import FiltreBox from "@/components/app-filtres/components/box.vue";
import AppLayout from "@/components/app-layout.vue";
import { Individu } from "@/models/Individu";
import { PaletteDocument } from "@/models/PaletteDocument";
import { TarifActiviteDocument } from "@/models/TarifActiviteDocument";
import { TarifEventSchedulerActiviteDocument } from "@/models/TarifEventSchedulerActiviteDocument";
import { VieQuotidienneDocuments } from "@/models/VieQuotidienneDocument";
import { FiltrePointage } from "@/models/_FiltresPointage";
import { FiltreScolarite } from "@/models/_FiltresScolarite";
import router from "@/router";
import store from "@/store";
import { CLOSE_LOADING, SHOW_LOADING } from "@/store/types";
import { utils } from "@/util";
import { Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";
import IndividusScrollAlphabet from "./components/pointage-scrollalphabet.vue";
import PointageTable from "./components/pointage-table.vue";
export default Vue.extend({
  beforeRouteEnter(from, to, next) {
    store.dispatch(SHOW_LOADING);
    store.dispatch("individus/fetchDataForFilter").catch((error: any) => {
      store.dispatch(CLOSE_LOADING);
    });
    store
      .dispatch("individus/fetchListIndividus", "activite")
      .then(() => {
        store
          .dispatch("pointages/fetchAll")
          .then(() => {
            next((vm: any) => {
              store.dispatch(CLOSE_LOADING);
              vm.initScolariteFilter();
              vm.initPointageFilter();
              next();
            });
          })
          .catch((error: any) => {
            store.dispatch(CLOSE_LOADING);
            next("/erreurs/" + error);
          });
      })
      .catch((error: any) => {
        store.dispatch(CLOSE_LOADING);
        next("/erreurs/" + error);
      });
  },
  beforeRouteLeave(to, from, next) {
    store
      .dispatch("individus/closeFiltre", "all")
      .then(() => {
        next();
      })
      .catch((error: any) => {
        next("/erreurs/" + error);
      });
  },
  components: {
    AppLayout,
    PointageTable,
    IndividusScrollAlphabet,
    FiltreBox,
  },
  data() {
    return {
      alphabet: [...Array(26)]
        .map((_, y) => String.fromCharCode(y + 65))
        .join(""),
      activeLettre: [] as Array<string>,
      showModalReserv: false,
      showModalPointage: false,
      showModalSupplements: false,
      temps: {} as TarifEventSchedulerActiviteDocument,
      supplement: {} as TarifActiviteDocument,
      filtreAutori: -2,
      filtreScolarite: new FiltreScolarite(),
      filtrePointage: new FiltrePointage(),
      selectedPageSize: 999,
      currentPage: 1,
      maxPage: 1,
      paginatedIndividus: [] as Array<Individu>,
    };
  },
  mounted() {
    this.maxPage = utils.calculateMaxPage(
      this.getFiltredListIndividus as Array<Individu>,
      this.selectedPageSize
    );

    this.paginatedIndividus = utils.paginate(
      this.getFiltredListIndividus,
      this.selectedPageSize,
      this.currentPage
    );
    this.activeLettre = [
      ...new Set(
        this.paginatedIndividus.map((ind: Individu) => ind.getDisplayName()[0])
      ),
    ];
    this.currentPage = 1;

  },
  computed: {
    ...mapGetters(["getFiltredListIndividusWithPointages"]),
    ...mapGetters("individus", [
      "getFiltredListIndividus",
      "getListIndividus",
      "getListClasses",
      "getListEcoles",
      "getListInstits",
      "getListNiveau",
      "getListVille",
      "getCurrentAnneeScolaire",
      "getListEtablissementScolaireNiveau",
      "getListClasseScolaireNiveau",
      "getListClasseScolaireEnseignant",
    ]),
    ...mapGetters("pointages", [
      "getListPointagesPrevi",
      "getListTempsAccueil",
      "getListSupplements",
      "getListTempsAccueilFiltred",
      "getListSupplementsFiltred",
      "getPointageEnCours",
      "getListPalettePresence",
      "getListPaletteAbsence",
      "getListGroupes",
      "getListRegim",
      "getVieQuoRegimeAli",
      "getSupplementsActifs",
      "getLastAction",
      "getPaletteEnCours",
      "getListSupplementsPrevi",
      "getIndividusPresents",
      "getIndividusFiltreesPresents"
    ]),
    ...mapGetters("etablissements", ["getCurrentEtablissement"]),
    ...mapGetters("activites", [
      "getDate",
      "getCurrentActivite",
      "getIsDateDiff",
    ]),
    ...mapGetters("session", [
      "getLocalDBStatus",
      "storeWillUpdate",
      "getMemDBStatus",
    ]),
  },
  methods: {
    showListeUrgence(filtred:string) {
      router.push({ name: "ListIndividusUrgence" , params: { filtred: filtred }});
    },
    infoEnfant(Enfant: Individu) {
      store.dispatch("individus/selectIndividu", Enfant);
    },
    pointerTAC(info: any) {
      store.dispatch("pointages/pointageTemps", info);
    },
    showPointageMasseModal(temps: TarifEventSchedulerActiviteDocument) {
      this.temps = temps;
      this.showModalPointage = true;
    },
    pointageMasse() {
      this.showModalPointage = false;
      store.dispatch("pointages/addPointageMasseAvecTemps", this.temps);
    },
    filtres(params: any) {
      if (typeof params === "undefined" || params.filtre !== "temps") {
        store.dispatch("individus/filtreListIndividus", params).then((e : any)=>{
          //console.log("liste individus temps : ", this.getFiltredListIndividus)
        })

      } else {
        store.dispatch("pointages/filterListTempsAccueil", params.value[0]).then(()=>{
        });
        store.dispatch("pointages/filterListSupplement", params.value[1]);
      }
    },
    closeFiltre(params: string) {
      if (params === "all") {
        store.dispatch("individus/closeFiltre", params);
        store.dispatch("pointages/filterListTempsAccueil");
        store.dispatch("pointages/filterListSupplement");
      } else {
        if (params !== "temps") {
          store.dispatch("individus/closeFiltre", params);
        } else {
          store.dispatch("pointages/filterListTempsAccueil");
          store.dispatch("pointages/filterListSupplement");
        }
      }
    },
    currentPalette(palette: PaletteDocument) {
      store.dispatch("pointages/setPaletteEncours", palette);
    },
    countRegim() {
      let regimCount = [] as Array<any>;
      this.getListRegim.forEach((regim: VieQuotidienneDocuments) => {
        let total: number = 0;
        total = this.getFiltredListIndividus.reduce(
          (acc: number, individu: Individu) =>
            individu.getRegimealimentaire_id() === regim.getId()
              ? (acc += 1)
              : (acc += 0),
          total
        );
        regimCount.push({
          regim_id: regim.getVieQuoRegimeAli().getType_regime(),
          count: total,
        });
      });
      return regimCount;
    },
    pointerSupplement(info: any) {
      store.dispatch("pointages/pointageSupplementTAC", info);
    },
    showSupplementsMasseModal(suppl: TarifActiviteDocument) {
      this.supplement = suppl;
      this.showModalSupplements = true;
    },
    supplementMasse() {
      this.showModalSupplements = false;

      store.dispatch("pointages/addSupplementMasse", this.supplement);
    },
    undoLastAction() {
      store.dispatch("pointages/undoLastActionTAC");
    },
    confReservation() {
      store.dispatch("pointages/confReservationTAC");
      this.showModalReserv = false;
    },
    showInfos(event: any) {
      let now = utils.getDateFromString(event, "YYYY-MM-DD");
      if (
        this.getCurrentActivite
          .getJours()
          .toLowerCase()
          .includes(now.format("dddd").slice(0, 2))
      ) {
        store.dispatch("activites/setCurrentDate", event);
        store.dispatch(SHOW_LOADING);
        store.dispatch("individus/fetchListIndividus", "activite").then(() => {
          store
            .dispatch("pointages/fetchAll")
            .then(() => {
              store.dispatch(CLOSE_LOADING);
              this.initScolariteFilter();
              this.initPointageFilter();
            })
            .catch((error: any) => {
              store.dispatch(CLOSE_LOADING);
              router.push("/erreurs/" + error);
            });
        });
      } else {
        router.push("/erreurs/no-seances-found");
      }
    },
    setFiltreAutori(autori: number) {
      this.filtreAutori = autori;
    },
    nextPage() {
      if (this.currentPage < this.maxPage) {
        this.currentPage++;
        this.paginatedIndividus = utils.paginate(
          this.getFiltredListIndividus,
          this.selectedPageSize,
          this.currentPage
        );
        this.activeLettre = [
          ...new Set(
            this.paginatedIndividus.map(
              (ind: Individu) => ind.getDisplayName()[0]
            )
          ),
        ];
      }
    },
    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.paginatedIndividus = utils.paginate(
          this.getFiltredListIndividus,
          this.selectedPageSize,
          this.currentPage
        );
        this.activeLettre = [
          ...new Set(
            this.paginatedIndividus.map(
              (ind: Individu) => ind.getDisplayName()[0]
            )
          ),
        ];
      }
    },
    changePageSize(size: number) {
      this.selectedPageSize = size;
      this.currentPage = 1;
      this.maxPage = utils.calculateMaxPage(
        this.getFiltredListIndividus as Array<Individu>,
        this.selectedPageSize
      );
      this.paginatedIndividus = utils.paginate(
        this.getFiltredListIndividus,
        this.selectedPageSize,
        this.currentPage
      );
      this.activeLettre = [
        ...new Set(
          this.paginatedIndividus.map(
            (ind: Individu) => ind.getDisplayName()[0]
          )
        ),
      ];
    },
    initScolariteFilter() {
      this.filtreScolarite.setListClasses(this.getListClasses);
      this.filtreScolarite.setListEtablissementScolaireNiveau(
        this.getListEtablissementScolaireNiveau
      );
      this.filtreScolarite.setListClasseScolaireNiveau(
        this.getListClasseScolaireNiveau
      );
      this.filtreScolarite.setListClasseScolaireEnseignant(
        this.getListClasseScolaireEnseignant
      );
      this.filtreScolarite.setListEcoles(this.getListEcoles);
      this.filtreScolarite.setListInstits(this.getListInstits);
      this.filtreScolarite.setListNiveau(this.getListNiveau);
      this.filtreScolarite.setCurrentAnneeScolaire(
        this.getCurrentAnneeScolaire
      );
    },
    initPointageFilter() {
      this.filtrePointage.setListTemps(this.getListTempsAccueil);
      this.filtrePointage.setPalettepresence(this.getListPalettePresence);
      this.filtrePointage.setPaletteabsence(this.getListPaletteAbsence);
      this.filtrePointage.setListGroupes(this.getListGroupes);
      this.filtrePointage.setListSuppplements(this.getListSupplements);
    },
  },
  watch: {
    getLocalDBStatus(newVal: string, oldVal: string) {
      if (oldVal === "change" && newVal === "paused") {
        store.dispatch("pointages/fetchListPointages").then((rep: any) => {
          store.dispatch("pointages/fetchSupplementActifs");
        });
      }
    },
    storeWillUpdate(newVal: string, oldVal: string) {
      if (!newVal && oldVal) {
        store.dispatch(SHOW_LOADING);
        store.dispatch("individus/fetchDataForFilter");
        store
          .dispatch("individus/fetchListIndividus", "activite")
          .then(() => {
            store
              .dispatch("pointages/fetchAll")
              .then(() => {
                store.dispatch(CLOSE_LOADING);
                this.initScolariteFilter();
                this.initPointageFilter();
              })
              .catch((error: any) => {
                store.dispatch(CLOSE_LOADING);
                router.push("/erreurs/" + error);
              });
          })
          .catch((error: any) => {
            store.dispatch(CLOSE_LOADING);
            router.push("/erreurs/" + error);
          });
      }
    },
    getFiltredListIndividus(newVal: Array<Individu>, oldVal: Array<Individu>) {
      this.currentPage = 1;
      this.maxPage = utils.calculateMaxPage(
        newVal as Array<Individu>,
        this.selectedPageSize
      );

      this.paginatedIndividus = utils.paginate(
        newVal,
        this.selectedPageSize,
        this.currentPage
      );
      this.activeLettre = [
        ...new Set(
          this.paginatedIndividus.map(
            (ind: Individu) => ind.getDisplayName()[0]
          )
        ),
      ];
    },
  },
});
